import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";

export default function Countdown() {
  let { event, time } = useParams();
  const [targetTime] = useState(moment.unix(time).utcOffset(-7));
  const [timer, setTimer] = useState({
    days: "0",
    hours: "0",
    minutes: "0",
    seconds: "0",
  });

  useEffect(() => {
    const startTimer = () => {
      const distance = moment.duration(targetTime.diff(moment()));
      const days = Math.floor(distance.asDays());
      const hours = distance.hours();
      const minutes = distance.minutes();
      const seconds = distance.seconds();

      distance.asSeconds() <= 0
        ? clearInterval(intervalId)
        : setTimer({ days, hours, minutes, seconds });
    };
    let intervalId = targetTime.isValid() && setInterval(startTimer, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [targetTime]);

  return (
    <div className="countdown-container">
      <div className="countdown-title">{event}</div>
      <div className="countdown-timer">
        <div className="countdown-time">
          <div className="countdown-time__value">{timer.days}</div>
          <div>Days</div>
        </div>
        <span>:</span>
        <div className="countdown-time">
          <div className="countdown-time__value">
            {timer.hours < 10 ? `0${timer.hours}` : timer.hours}
          </div>
          <div>Hours</div>
        </div>
        <span>:</span>
        <div className="countdown-time">
          <div className="countdown-time__value">
            {timer.minutes < 10 ? `0${timer.minutes}` : timer.minutes}
          </div>
          <div>Minutes</div>
        </div>
        <span>:</span>
        <div className="countdown-time">
          <div
            className={`countdown-time__value ${
              timer.seconds > 0 && "timer-seconds"
            }`}
          >
            {timer.seconds < 10 ? `0${timer.seconds}` : timer.seconds}
          </div>
          <div>Seconds</div>
        </div>
      </div>
      <div className="countdown-date">
        {targetTime.format("Do MMMM YYYY HH:mm (UTC -7)")}
      </div>
    </div>
  );
}
